/* eslint-disable */
// Cross-surface "open this order line" bridge (B1a). Dependency-free so
// utils/entityRoutes can import it without pulling the lazy Orders chunk into
// the main bundle — the same shape as lensBank/lensOpenBridge, for the same
// reason. requestOpenOrdersLine stashes the id (survives the cold-navigation
// race where OrdersPortal is not mounted yet) AND fires the 'open_orders_line'
// event (fast path when the portal is already mounted). OrdersPortal consumes
// both: it listens for the event, and on mount drains any pending id via
// peek/clear.
//
// B5-1 c3: a second slot of the same shape for the DESK — a `pi` card (the
// clock's notifications carry entity_type 'pi', entity_id = orders_pis.id)
// opens the Desk order card through requestOpenDeskOrder / 'open_desk_order'.
// Two slots, not one with a kind flag: a line is the Book's, an order is the
// Desk's, and the portal drains each into its own store action.
let _pending = null;
let _pendingDesk = null;

export function requestOpenOrdersLine(lineId) {
  _pending = lineId || null;
  try { window.dispatchEvent(new CustomEvent('open_orders_line', { detail: { id: lineId } })); } catch (_) {}
}
export const peekPendingOrdersLine = () => _pending;
export const clearPendingOrdersLine = () => { _pending = null; };

export function requestOpenDeskOrder(piId) {
  _pendingDesk = piId || null;
  try { window.dispatchEvent(new CustomEvent('open_desk_order', { detail: { id: piId } })); } catch (_) {}
}
export const peekPendingDeskOrder = () => _pendingDesk;
export const clearPendingDeskOrder = () => { _pendingDesk = null; };

// C7 · a third slot of the same shape: "open the Collection Wall" — the
// orders.collection_moved bell (entity_type 'collection_run', entity_id = the
// sync run). The run is not a place, the Wall is; the id is kept only so the
// slot has something to drain.
let _pendingCollection = null;
export function requestOpenCollectionWall(runId) {
  _pendingCollection = runId || 'wall';
  try { window.dispatchEvent(new CustomEvent('open_collection_wall', { detail: { id: _pendingCollection } })); } catch (_) {}
}
export const peekPendingCollectionWall = () => _pendingCollection;
export const clearPendingCollectionWall = () => { _pendingCollection = null; };
